import { useState } from 'react';
import { AlertTriangle, X, ChevronDown, ChevronUp } from 'lucide-react';

// Iter 457 : guide de reinstallation pour les employes bloques par
// l'ancienne app "Pointage MAA" (WebAPK obsolete bloque par Play Protect)
export const OldAppBanner = () => {
  const isAndroid = /android/i.test(navigator.userAgent || '');
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem('old_app_banner_dismissed') === '1'; } catch { return false; }
  });
  const [open, setOpen] = useState(false);

  if (!isAndroid || dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem('old_app_banner_dismissed', '1'); } catch {}
  };

  return (
    <div className="w-full max-w-md relative z-10 mb-3" data-testid="old-app-banner">
      <div className="bg-amber-50 border border-amber-300 rounded-2xl shadow-lg px-4 py-3">
        <div className="flex items-start gap-2.5">
          <AlertTriangle className="w-4 h-4 text-amber-600 mt-0.5 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold text-amber-800 leading-snug">
              Message "Appli non sécurisée bloquée" avec l'ancienne app Pointage MAA ?
            </p>
            <button
              type="button"
              onClick={() => setOpen(o => !o)}
              className="mt-1 inline-flex items-center gap-1 text-[11px] font-semibold text-amber-700 underline underline-offset-2"
              data-testid="old-app-banner-toggle"
            >
              {open ? 'Masquer la solution' : 'Voir la solution (2 min)'}
              {open ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
            </button>
            {open && (
              <ol className="mt-2 space-y-1.5 text-[11px] text-amber-900 list-decimal pl-4" data-testid="old-app-banner-steps">
                <li>Appui long sur l'icône <b>Pointage MAA</b> de votre écran d'accueil → <b>Désinstaller</b></li>
                <li>Ouvrez <b>Chrome</b> et allez sur <b>logyra.fr</b></li>
                <li>Menu Chrome (⋮) → <b>« Installer l'application »</b></li>
                <li>La nouvelle app <b>Logyra RH</b> est installée, plus aucun blocage ✔</li>
              </ol>
            )}
          </div>
          <button type="button" onClick={dismiss} className="text-amber-500 hover:text-amber-700 shrink-0" aria-label="Fermer" data-testid="old-app-banner-close">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
